import { render, staticRenderFns } from "./CorporationD.vue?vue&type=template&id=348b9c5f&scoped=true"
import script from "./CorporationD.vue?vue&type=script&lang=js"
export * from "./CorporationD.vue?vue&type=script&lang=js"
import style0 from "./CorporationD.vue?vue&type=style&index=0&id=348b9c5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348b9c5f",
  null
  
)

export default component.exports